import { HELP_URL_CALL_RECORDING } from 'src/constants/help.constants';
import { Feature } from 'src/types/features.types';

const recordingLight = '/images/recording-avatars-light.png';
const recordingDark = '/images/recording-avatars-dark.png';
const universalFeedbackCapture = '/images/universal-feedback-capture.png';

export const featureContentMap: Record<Feature, {
  image: string;
  imageDark?: string;
  title: string;
  description: string;
  ctas: {
    label: string;
    action: 'request-access' | 'url';
    url?: string;
  }[];
} | null> = {
  [Feature.MeetingIntegration]: {
    image: recordingLight,
    imageDark: recordingDark,
    title: 'Introducing Call recording',
    description: 'Record your calls and automatically fetch transcripts as Cycle feedback. It works with Zoom, Google Meet & Microsoft Teams.',
    ctas: [
      {
        label: 'Request access',
        action: 'request-access',
      },
      {
        label: 'Learn more',
        action: 'url',
        url: HELP_URL_CALL_RECORDING,
      },
    ],
  },
  [Feature.UniversalFeedbackCapture]: {
    image: universalFeedbackCapture,
    imageDark: universalFeedbackCapture,
    title: 'Universal Feedback Capture',
    description: 'Capture feedback from anywhere with one drag and drop. Voice notes, videos, images, PDFs, you name it. Give it a try!',
    ctas: [
    ],
  },
};

export const getNewFeaturesToasterId = (feature: Feature) => {
  return `new-features-${feature}`;
};
